export default {
    lastreadings_details_account_name: "Cuenta",
    lastreadings_details_device_id: "Serial",
    lastreadings_details_manufacturer: "Fabricante",
    lastreadings_details_age: "Edad (Días)",
    lastreadings_details_event_name: "Nombre del evento",
    lastreadings_details_last_message_time: "Última lectura",
    lastreadings_details_devices: "Dispositivos",
    lastreadings_details_warning: "Advertencia",
    lastreadings_details_device_name: "Nombre del dispositivo",
    lastreadings_details_date: "Fecha",
}